import { SVGInterface } from "../../interface";

const SubmittedTracker = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="20"
    height="19"
    viewBox="0 0 20 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M4.95052 1.58398C4.08424 1.58398 3.36719 2.30103 3.36719 3.16732V15.834C3.36719 16.7003 4.08424 17.4173 4.95052 17.4173H14.4505C15.3168 17.4173 16.0339 16.7003 16.0339 15.834V6.33398L11.2839 1.58398H4.95052ZM4.95052 3.16732H10.4922V7.12565H14.4505V15.834H4.95052V3.16732ZM10.4922 9.50065V11.084H6.53385V12.6673H10.4922V14.2507L12.8672 11.8757L10.4922 9.50065Z"
      fill={color || "black"}
    />
  </svg>
);

export default SubmittedTracker;
